import { ActionIcon, Button, Space } from "@mantine/core";
import { IconPlus, IconTrash } from "@tabler/icons-react";
import type { ReactNode } from "react";
import { appendUUID, type IDElement } from "../../models/IDElement";
import { SortableList } from "./SortableList";

type ManagableListProps<T extends IDElement> = {
  reorderListItem: (from: number, to: number) => void;
  label?: string;
  itemRender: (index: number) => ReactNode;
  values: T[];
  maw?: string;
  onAdd: (newElement: T) => void;
  onDelete: (index: number) => void;
  defaultProps: Omit<T, "id">;
  detailLabels?: ReactNode;
};

export function ManagableList<T extends IDElement>({
  onAdd,
  onDelete,
  itemRender,
  values,
  defaultProps,
  detailLabels,
  ...props
}: ManagableListProps<T>) {
  const itemRenderWithDelete = (index: number) => {
    return (
      <>
        {itemRender(index)}
        <ActionIcon disabled={index === 0 && values.length === 1} onClick={() => onDelete(index)} variant="subtle" color="red">
          <IconTrash />
        </ActionIcon>
      </>
    );
  };

  const _onAdd = () => onAdd(appendUUID(defaultProps) as T);

  const _detailLabels = (
    <>
      {detailLabels}
      <Space w={28} />
    </>
  );

  return (
    <>
      <SortableList values={values} itemRender={itemRenderWithDelete} detailLabels={_detailLabels} {...props} />
      <Button variant="subtle" leftSection={<IconPlus />} onClick={() => _onAdd()}>
        Feld hinzufügen
      </Button>
    </>
  );
}
